import template from './template.html'

angular
  .module('contabilidad.catalogosexternos')
  .component('contabilidadCatalogosexternosClientesagItem', {
    template,
    bindings: {
      data: '<',
    },
    controller: Controller,
  })
Controller.$inject = ['CatalogosExternosClientesAg']

function Controller (CatalogosExternosClientesAg) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.editar = editar

  $ctrl.editando = false
  $ctrl.expandir = false

  function $onInit () {
    $ctrl.copia = $ctrl.data.cta_contable
  }

  function editar () {
    $ctrl.editando = true
    CatalogosExternosClientesAg.put($ctrl.data.id_cliente, $ctrl.data.cta_contable)
      .then(function (response) {
        $ctrl.editando = false
        $ctrl.expandir = false
      })
      .finally(function () {
        $ctrl.expandir = false
      })
  }
}





// WEBPACK FOOTER //
// ./src/contabilidad/catalogosexternos/components/clientesag/item/component.js